/**
* reducers for the fund
*
* Created by Min on 16/08/18
*/

import C from '../constants'

const initState = {
    documentsLoading : false,
    documentListData: [],
    documentCategories: [],
    selectableTaxYears: getTaxYears(),
    memberDocFolderLookup: {},
    docusignDocuments: [],
}

export const documentsState = (state = initState, action) => {

    switch(action.type) {

        case C.SET_DOCUMNENTS_LOADER:
            return {
                ...state,
                documentsLoading: action.payload
            }

        case C.SET_DOCUMNENTS_DATA:
            return {
                ...state,
                documentListData: action.payload
            }

        case C.SET_DOC_CATEGORIES:

            return {
                ...state,
                documentCategories: action.payload
            }

        case C.CLEAR_DOCUMENTS_DATA:
            return {
                ...state,
                documentListData: [],
                docusignDocuments: [],
            }

        case C.SET_MEMBER_DOC_FOLDER_LOOKUP:
            return {
                ...state,
                memberDocFolderLookup: action.payload
            }

        case C.SET_DOCUSIGN_DATA:
            return {
                ...state,
                docusignDocuments: action.payload
            }

        default: return state
    }
}

function getTaxYears() {
    
    let date = new Date()
    let taxYears = []
    let taxYear = date.getFullYear();

    taxYears.push({ value: -1, label: 'General (not related to a tax year)' })

    if (date.getMonth() > 6) {
        taxYear++
    }

    for(var i = 0; i < 5; i++) {
        taxYears.push({
            value: i,
            label: (taxYear-i-1).toString() + "-" + (taxYear-i).toString()}
        )
    }

    return taxYears;
}


// WEBPACK FOOTER //
// ./src/reducers/documentsReducers.js